import React, { useEffect, useState } from 'react';
import ConnectionMonitor from '../utils/connectionMonitor';
import ConnectionErrorPopup from './ConnectionErrorPopup';

interface ConnectionMonitorProviderProps {
  children: React.ReactNode;
}

const ConnectionMonitorProvider: React.FC<ConnectionMonitorProviderProps> = ({ children }) => {
  const [isConnected, setIsConnected] = useState(true);
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  useEffect(() => {
    const connectionMonitor = ConnectionMonitor.getInstance();

    const handleConnectionChange = (connected: boolean) => {
      setIsConnected(connected);
      if (!connected) {
        setShowErrorPopup(true);
      } else {
        // Connection restored, hide popup after a short delay
        setTimeout(() => {
          setShowErrorPopup(false);
        }, 2000);
      }
    };

    // Add listener for connection changes
    connectionMonitor.addListener(handleConnectionChange);

    // Start monitoring the connection
    connectionMonitor.startMonitoring(15000); // Check every 15 seconds

    // Cleanup on unmount
    return () => {
      connectionMonitor.removeListener(handleConnectionChange);
      connectionMonitor.stopMonitoring();
    };
  }, []);

  const handleClosePopup = () => {
    setShowErrorPopup(false);
  };

  return (
    <>
      {children}
      <ConnectionErrorPopup 
        isVisible={showErrorPopup && !isConnected} 
        onClose={handleClosePopup} 
      />
    </>
  );
};

export default ConnectionMonitorProvider;